import { useEffect, React, useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import RtlLayout from "layouts/rtl";
import AdminLayout from "layouts/admin";
import AuthLayout from "layouts/auth";
import Private from "routes/Private";
import Public from "routes/Public";
import Swal from "sweetalert2";
import { LOGOUT } from "store/features/slices/userSlice";
import { useDispatch } from "react-redux";

const App = () => {
  const dispatch = useDispatch();

  const checkTokenExpiration = () => {
    const token = localStorage.getItem('userToken'); // O donde guardes tu token
    if (!token) return;

    const decodedToken = JSON.parse(atob(token.split('.')[1]));
    const currentTime = Date.now() / 1000;

    if (decodedToken.exp < currentTime) {
      let timerInterval;
      Swal.fire({
        title: "Cierre de sesión automático!",
        html: "Token expirado, la sesión se cerrará en <b></b> segundos.",
        timer: 10000,
        timerProgressBar: true,
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
          const timer = Swal.getPopup().querySelector("b");
          timerInterval = setInterval(() => {
            timer.textContent = `${Math.floor(Swal.getTimerLeft() / 1000)}`;
          }, 500);
        },
        willClose: () => {
          clearInterval(timerInterval);
        }
      }).then((result) => {
        if (result.dismiss === Swal.DismissReason.timer) {
          dispatch(LOGOUT('userToken'));
        }
      });
    }
  };

  useEffect(() => {
    const intervalId = setInterval(checkTokenExpiration, 15000); // Verificar cada segundo

    return () => clearInterval(intervalId); // Limpiar el intervalo al desmontar el componente
  }, []);

  return (
    <Routes>
      <Route path="auth/*" element={
        <Public>
          <AuthLayout />
        </Public>}
      />
      <Route path="admin/*" element={
        <Private>
          <AdminLayout />
        </Private>}
      />
      <Route path="rtl/*" element={
        <Private>
          <RtlLayout />
        </Private>}
      />
      <Route path="/" element={
        <Private>
          <Navigate to="/admin" replace />
        </Private>}
      />
    </Routes>
  );
};

export default App;
